import React from "react";
import Head from "next/head";

type CriticalImageProps = {
  dpi?: string;
  type?: string;
  mobile?: string;
  imgClass?: string;
  wrapClass?: string;
} & React.ImgHTMLAttributes<HTMLImageElement>;

const CriticalImage = ({
  dpi = "-2x",
  type = "png",
  mobile = "mobile",
  imgClass,
  wrapClass,
  src,
  alt,
  ...props
}: CriticalImageProps) => {
  let mimeType = type === "png" ? "image/png" : "image/jpeg";

  return (
    <>
      <Head>
        <link
          rel="preload"
          as="image"
          imageSrcSet={`${src}-${mobile}.webp, ${src}-${mobile}${dpi}.webp 2x`}
          media="(max-width:767px)"
        />
        <link
          rel="preload"
          as="image"
          imageSrcSet={`${src}.webp, ${src}${dpi}.webp 2x`}
          media="(min-width:767px)"
        />
      </Head>
      <picture className={`${wrapClass ? wrapClass : ""}`}>
        <source
          srcSet={`${src}-${mobile}.webp, ${src}-${mobile}${dpi}.webp 2x`}
          type="image/webp"
          media="(max-width:767px)"
        />
        <source
          srcSet={`${src}-${mobile}.${type}, ${src}-${mobile}${dpi}.${type} 2x`}
          type={mimeType}
          media="(max-width:767px)"
        />
        <source
          srcSet={`${src}.webp, ${src}${dpi}.webp 2x`}
          type="image/webp"
        />
        <source
          srcSet={`${src}.${type}, ${src}${dpi}.${type} 2x`}
          type={mimeType}
        />
        <img
          src={`${src}.${type}`}
          alt={alt}
          className={imgClass ? imgClass : ""}
          {...props}
        />
      </picture>
    </>
  );
};

export default CriticalImage;
